export const PLATFORMS = {
  ACC: 'acc',
  BIM360: 'bim360'
};
export const ENVS = {
  QA: 'QA',
  STAGING: 'STAGING',
  PRODUCTION: 'PRODUCTION'
};
export const APIGEE_URL = {
  [ENVS.QA]: 'https://developer-stg.api.autodesk.com',
  [ENVS.STAGING]: 'https://developer-stg.api.autodesk.com',
  [ENVS.PRODUCTION]: 'https://developer.api.autodesk.com'
};
export const OXYGEN_URL = {
  [ENVS.QA]: 'https://accounts-staging.autodesk.com',
  [ENVS.STAGING]: 'https://accounts-staging.autodesk.com',
  [ENVS.PRODUCTION]: 'https://accounts.autodesk.com'
};
export const USER_PROFILE_URL = {
  [ENVS.QA]: 'https://profile-stg.autodesk.com',
  [ENVS.STAGING]: 'https://profile-stg.autodesk.com',
  [ENVS.PRODUCTION]: 'https://profile.autodesk.com'
};
export const CPA_HOSTNAMES = {
  [ENVS.QA]: 'cpa-qa.autodesk.com',
  [ENVS.STAGING]: 'cpa-staging.autodesk.com',
  [ENVS.PRODUCTION]: 'cpa.autodesk.com'
};
export const BC_HOSTNAMES = {
  [ENVS.QA]: '',
  [ENVS.STAGING]: 'app-stage.buildingconnected.com',
  [ENVS.PRODUCTION]: 'app.buildingconnected.com'
};
export const BIM360_ADMIN_URL = {
  [ENVS.QA]: "".concat(APIGEE_URL[ENVS.QA], "/ea-api-qa"),
  [ENVS.STAGING]: "".concat(APIGEE_URL[ENVS.STAGING], "/ea-api"),
  [ENVS.PRODUCTION]: "".concat(APIGEE_URL[ENVS.PRODUCTION], "/ea-api")
};
export const ADMIN_API_URL = {
  [ENVS.QA]: "".concat(APIGEE_URL[ENVS.QA], "/bim360-qa/admin"),
  [ENVS.STAGING]: "".concat(APIGEE_URL[ENVS.STAGING], "/bim360/admin"),
  [ENVS.PRODUCTION]: "".concat(APIGEE_URL[ENVS.PRODUCTION], "/bim360/admin")
};
export const ADMIN_CONSTRUCTION_API_URL = {
  [ENVS.QA]: "".concat(APIGEE_URL[ENVS.QA], "/construction-qa/admin"),
  [ENVS.STAGING]: "".concat(APIGEE_URL[ENVS.STAGING], "/construction/admin"),
  [ENVS.PRODUCTION]: "".concat(APIGEE_URL[ENVS.PRODUCTION], "/construction/admin")
};
export const DOCS_API_V1_URL = {
  [ENVS.QA]: "".concat(APIGEE_URL[ENVS.QA], "/ea-dm-qa/v1"),
  [ENVS.STAGING]: "".concat(APIGEE_URL[ENVS.STAGING], "/dm-staging/v1"),
  [ENVS.PRODUCTION]: "".concat(APIGEE_URL[ENVS.PRODUCTION], "/dm/v1")
};
export const RELATIONSHIP_API_URL = {
  [ENVS.QA]: "".concat(APIGEE_URL[ENVS.QA], "/bim360/relationship-dev"),
  [ENVS.STAGING]: "".concat(APIGEE_URL[ENVS.STAGING], "/bim360/relationship"),
  [ENVS.PRODUCTION]: "".concat(APIGEE_URL[ENVS.PRODUCTION], "/bim360/relationship")
};
export const REPORTS_V2_URL = {
  [ENVS.QA]: "".concat(APIGEE_URL[ENVS.QA], "/reports-qa/v2"),
  [ENVS.STAGING]: "".concat(APIGEE_URL[ENVS.STAGING], "/reports/v2"),
  [ENVS.PRODUCTION]: "".concat(APIGEE_URL[ENVS.PRODUCTION], "/reports/v2")
};
export const FORMS_API_URL = {
  [ENVS.QA]: "".concat(APIGEE_URL[ENVS.QA], "/construction/forms-qa"),
  [ENVS.STAGING]: "".concat(APIGEE_URL[ENVS.STAGING], "/construction/forms"),
  [ENVS.PRODUCTION]: "".concat(APIGEE_URL[ENVS.PRODUCTION], "/construction/forms")
};
export const BIM360_HOSTNAMES = {
  [ENVS.QA]: 'b360-qa.autodesk.com',
  [ENVS.STAGING]: 'b360-staging.autodesk.com',
  [ENVS.PRODUCTION]: 'b360.autodesk.com'
};
export const BIM360_EMEA_HOSTNAMES = {
  [ENVS.QA]: '',
  [ENVS.STAGING]: 'b360-staging.eu.autodesk.com',
  [ENVS.PRODUCTION]: 'b360.eu.autodesk.com'
};
//# sourceMappingURL=envConsts.js.map